window.dataLayer = window.dataLayer || [];

import { clickHandler, determineActionText, queryURL } from '@/scripts/analytics/analytics.methods';

const eventName = 'bannerNotification_tracking';
const actionPropTitle = 'bannerNotification_action';
const labelPropTitle = 'bannerNotification_label';

const elements = {
  bannerTitleEl: document.querySelector('.js-banner-title-ga'),
  bannerLinks: [...document.querySelectorAll('.c-banner-notification__description a')],
  ctaLink: document.querySelector('.js-banner-cta-ga'),
};

function bindEventListener(el) {
  el.addEventListener(
    'click',
    clickHandler.bind(this, {
      event: eventName,
      actionProp: actionPropTitle,
      labelProp: labelPropTitle,
      action: `Click - ${getTitle()} -${isCTA(el)} ${determineActionText(el)}`,
      label: queryURL(el),
    }),
  );
}

function getTitle() {
  return elements.bannerTitleEl.textContent;
}

function isCTA(el) {
  return el === elements.ctaLink ? ` CTA -` : ``;
}

function init() {
  if (!elements.bannerLinks.length && !elements.ctaLink) {
    return;
  }

  if (elements.bannerLinks.length) {
    elements.bannerLinks.forEach(bindEventListener);
  }

  if (elements.ctaLink) {
    bindEventListener(elements.ctaLink);
  }
}

export default init;
